module.exports = __webpack_public_path__ + "img/lite-beach-2.3b5c1284.jpg";